import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { IServerErrorResponse } from '../../../types';

interface IProps {
  token: string;
  accountingNumber: string;
  routingNumber: string;
}

export const useRequestedVendorDetailsSubmit = (
  onError: (error: IServerErrorResponse) => void,
) => useMutation(
  'useRequestedVendorDetailsSubmit',
  async ({ token, accountingNumber, routingNumber }: IProps) => {
    const res = await httpService.post('/api/v1/public/bill', {
      token,
      billAchAccountPaymentData: {
        accountNumber: accountingNumber,
        routingNumber,
      },
    });
    return res.data;
  },
  {
    onError,
  },
);
